module.exports = __webpack_public_path__ + "img/ics_o_print.0c8b4b4f.svg";